import Joi from '@hapi/joi'

export const collectionPointSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group Name"),
    factoryID: Joi.number().invalid(0).required().label("Factory Name"),
    estateID: Joi.number().invalid(0).required().label("Estate Name"),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Category"),
    collectionpointName: Joi.string().required().label("Collectionpoint Name"),
    collectionpointCode: Joi.string().required().label("Collectionpoint Code"),
    collectionpointLocation: Joi.string().required().label("Collectionpoint Location"),
    isActive: Joi.boolean().label("Active")

}














